import React from "react";
import MetaTags from "react-meta-tags";

const Affiliates = () => {
  return (
    <div>
      <MetaTags>
        <title>Set Title</title>
        <meta
          name="description"
          content="Idatahost is the best web hosting provider"
        />
      </MetaTags>
      <div className="main">
        {/*hero section start*/}
        <section className="ptb-120 gradient-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-7 col-lg-8">
                <div className="hero-content-wrap text-white text-center position-relative">
                  <h1 className="text-white">Hosting Affiliate Program</h1>
                  <p className="lead">
                    We offer nice commissions, however most of our affiliates
                    endorse US for a unique reason the standard of service. If
                    you would like to advocate a number that will not fail your
                    customers, readers, be part of our affiliate program!
                  </p>
                  <a href="#" className="btn btn-brand-03 btn-lg">
                    Join Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*hero section end*/}

        {/*affiliates promo contents start*/}
        <section id="features" className="feature-tab-section ptb-100">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <h2>High Commissions with Weekly Payouts Thresholds</h2>
                  <p className="lead">
                    Globally parallel task granular alignments through excellent
                    intellectual capital. Globally deploy vertical leadership.
                  </p>
                  <ul className="list-unstyled tech-feature-list">
                    <li className="py-1">
                      <span className="fas fa-check-circle text-success mr-2"></span>
                      1-5 Sales /mo <strong>$50 </strong>/sale
                    </li>
                    <li className="py-1">
                      <span className="fas fa-check-circle text-success mr-2"></span>
                      6-10 Sales /mo <strong>$75</strong> /sale
                    </li>
                    <li className="py-1">
                      <span className="fas fa-check-circle text-success mr-2"></span>
                      11-20 Sales /mo <strong>$100</strong> /sale
                    </li>
                    <li className="py-1">
                      <span className="fas fa-check-circle text-success mr-2"></span>
                      21+ Sales /mo <strong>Custom Commissions</strong>
                    </li>
                    <li className="py-1">
                      <span className="fas fa-check-circle text-success mr-2"></span>
                      <strong>24/7</strong> Customer Support
                    </li>
                  </ul>
                  <div className="action-btns mt-4">
                    <a href="#" className="btn btn-outline-brand-01">
                      Learn More
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <img
                    src="assets/img/affliate.png"
                    alt="hosting"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="row align-items-center mt-5">
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <img
                    src="assets/img/affliate-1.png"
                    alt="hosting"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="col-md-6 col-lg-6">
                <div className="cta-new-wrap">
                  <h2>Easy Ways to Refer Clients and Earn Commissions</h2>
                  <p>
                    Phosfluorescently fashion front-end web-readiness vis-a-vis
                    robust networks. Interactively redefine frictionless
                    interfaces after timely benefits. Continually drive
                    maintainable vortals via synergistic metrics. Intrinsicly
                    fabricate scalable web-readiness before seamless
                    technologies.
                  </p>
                  <p>
                    Credibly foster customer directed meta-services and cost
                    effective process improvements. Monotonectally build
                    adaptive catalysts for change rather than cost effective
                    results.
                  </p>
                  <div className="action-btns mt-4">
                    <a href="#" className="btn btn-outline-brand-01">
                      Learn More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*affiliates promo contents end*/}

        {/*feature section start*/}
        <section className="feature-section ptb-100 gray-light-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center">
                  <h2>Best Features For Affiliate Success</h2>
                  <p className="lead">
                    These features come standard in all of our hosting plans.
                    Dynamically extend imperatives through open-source quickly
                    niche markets.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-4">
                <div className="features-box mt-4 text-center border rounded p-4 bg-white">
                  <div className="features-box-icon mb-3">
                    <span className="ti-panel icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Attractive visuals</h5>
                    <p>
                      Our intuitive control panel gives you admin access to all
                      of your DreamHost products easily.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box mt-4 text-center border rounded p-4 bg-white">
                  <div className="features-box-icon mb-3">
                    <span className="ti-thumb-up icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Complimentary hosting</h5>
                    <p>
                      Tech veterans, geeks, and nerds are all standing by to
                      optimize your experience whether.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box mt-4 text-center border rounded p-4 bg-white">
                  <div className="features-box-icon mb-3">
                    <span className="ti-mouse-alt icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Reliable in-house tracking</h5>
                    <p>
                      No need to dig into a bunch of documentation. Simply
                      install web apps like WordPress, Joomla!.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box mt-4 text-center border rounded p-4 bg-white">
                  <div className="features-box-icon mb-3">
                    <span className="ti-timer icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Campaign tools</h5>
                    <p>
                      With multiple datacenter locations, redundant cooling,
                      emergency generators and monitoring.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box mt-4 text-center border rounded p-4 bg-white">
                  <div className="features-box-icon mb-3">
                    <span className="ti-harddrives icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Great affiliate support</h5>
                    <p>
                      With SSDs, your website, caching, and database queries are
                      faster by our calculations.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4">
                <div className="features-box mt-4 text-center border rounded p-4 bg-white">
                  <div className="features-box-icon mb-3">
                    <span className="ti-cup icon-size-md color-primary"></span>
                  </div>
                  <div className="features-box-content">
                    <h5>Custom landing page</h5>
                    <p>
                      No question is too simple, or too complex for our team of
                      experts. Synergistically synergize.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*feature section end*/}

        {/*call to action new section start*/}
        <section className="ptb-60 primary-bg">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-7">
                <div className="cta-content-wrap text-white text-center">
                  <h2 className="text-white">Ready To Become An Affiliate?</h2>
                  <p className="lead">
                    Holisticly optimize enterprise networks and intuitive supply
                    chains. Enthusiastically embrace standards compliant growth.
                  </p>
                  <a href="#" className="btn btn-brand-03 mt-2">
                    Join Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*call to action new section end*/}

        {/*faq section start*/}
        <section id="faq" className="ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9 col-lg-8">
                <div className="section-heading text-center mb-5">
                  <h2>Frequently Asked Queries</h2>
                  <p>
                    Efficiently productivate reliable paradigms before
                    ubiquitous models. Continually utilize frictionless
                    expertise whereas tactical relationships. Still have
                    questions? Contact us
                  </p>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-md-12 col-lg-12">
                <div id="accordion" className="accordion faq-wrap">
                  <div className="card mb-3">
                    <a
                      className="card-header"
                      data-toggle="collapse"
                      href="#collapse0"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        Which license do I need?
                      </h6>
                    </a>
                    <div
                      id="collapse0"
                      className="collapse show"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Nihil anim keffiyeh helvetica, craft beer labore wes
                          anderson cred nesciunt sapiente ea proident. Ad vegan
                          excepteur butcher vice lomo. Leggings occaecat craft
                          beer farm-to-table, raw denim aesthetic synth nesciunt
                          you probably haven&#x27;t heard of them accusamus
                          labore sustainable VHS.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card my-3">
                    <a
                      className="card-header collapsed"
                      data-toggle="collapse"
                      href="#collapse1"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        How do I get access to a theme?
                      </h6>
                    </a>
                    <div
                      id="collapse1"
                      className="collapse"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Ad vegan excepteur butcher vice lomo. Leggings
                          occaecat craft beer farm-to-table, raw denim aesthetic
                          synth nesciunt you probably haven&#x27;t heard of them
                          accusamus. Seamlessly optimize empowered testing
                          procedures before revolutionary processes.
                          Progressively facilitate client-centered technologies
                          whereas extensive users. Authoritatively.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card my-3">
                    <a
                      className="card-header collapsed"
                      data-toggle="collapse"
                      href="#collapse2"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        How do I see previous orders?
                      </h6>
                    </a>
                    <div
                      id="collapse2"
                      className="collapse"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Nihil anim keffiyeh helvetica, craft beer labore wes
                          anderson cred nesciunt sapiente ea proident. Ad vegan
                          excepteur butcher vice lomo. Leggings occaecat craft
                          beer farm-to-table, raw denim aesthetic synth nesciunt
                          you probably haven&#x27;t heard of them accusamus
                          labore sustainable VHS.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card mt-3">
                    <a
                      className="card-header collapsed"
                      data-toggle="collapse"
                      href="#collapse3"
                      aria-expanded="false">
                      <h6 className="mb-0 d-inline-block">
                        Support related issues for the template?
                      </h6>
                    </a>
                    <div
                      id="collapse3"
                      className="collapse"
                      data-parent="#accordion">
                      <div className="card-body white-bg">
                        <p>
                          Nihil anim keffiyeh helvetica, craft beer labore wes
                          anderson cred nesciunt sapiente ea proident. Ad vegan
                          excepteur butcher vice lomo. Leggings occaecat craft
                          beer farm-to-table. Professionally embrace customer
                          directed value vis-a-vis high-quality portals. Quickly
                          underwhelm B2C users with maintainable benefits.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*faq section end*/}
      </div>
    </div>
  );
};

export default Affiliates;
